import React, { useEffect, useState } from 'react';
import { CardCvcElement, CardElement, CardExpiryElement, CardNumberElement, injectStripe, PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';
import './CheckoutForm.css';
import { paymentDetailService, updateProfileService } from '../services/userService';
import { Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../Context/AuthProvider';
const CARD_ELEMENT_OPTIONS = {
    style: {
        base: {
            color: "#32325d",
            fontFamily: 'Poppins',
            fontSmoothing: "antialiased",
            fontSize: "20px",
            "::placeholder": {
                color: "#aab7c4",
            },
        },
        invalid: {
            color: "#fa755a",
            iconColor: "#fa755a",
        },
    },
};
const CheckoutForm = ({ selectedPrice, subscriptionType }) => {
    const [clientSecret, setClientSecret] = useState("");
    const [error, setError] = useState(false);
    const [isLoading, setLoader] = useState(false);
    const navigate = useNavigate();
    const { user, updateUserProfile } = useAuth()
    const stripe = useStripe();
    const elements = useElements();
    useEffect(() => {
        getClientSecret();
    }, [])
    const updateProfile = async () => {
        try {
            setLoader(true)
            const response = await updateProfileService({ ...user, packType: subscriptionType });
            if (response.data) {
                updateUserProfile();
                setLoader(false);
                // toast.success(response?.data);
            }
        } catch (err) {
            console.log(err)
            setLoader(false)
        }
    };
    const getClientSecret = async () => {
        try {
            const params = {
                "amount": selectedPrice * 100,
                "currency": "INR",
            };
            const response = await paymentDetailService(params);
            if (response.data) {
                setClientSecret(response?.data);
            }
        } catch (err) {
            console.log(err)
        }
    };
    const renderError = (msg, value, style) => {
        return (
            value ? (
                <h6 className="blog_error_text4 signUpMsg12 mt-2" style={{ marginBottom: -60, marginTop: style !== undefined ? 10 : -10 }}>
                    {msg}
                </h6>) : null)
    }
    const handleSubmit = async (event) => {
        // We don't want to let default form submission happen here,
        // which would refresh the page.
        event.preventDefault();
        setLoader(true)
        if (!stripe || !elements) {
            // Stripe.js hasn't yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.

            setError(true);
            return;
        }
        const result = await stripe.confirmCardPayment(clientSecret, {
            payment_method: {
                card: elements.getElement(CardElement),
                billing_details: {
                    name: user?.name,
                },
            }
        });
        if (result.error) {
            // Show error to your customer (for example, insufficient funds)
            setLoader(false);
            toast.error("Please enter card details!");
        } else {
            // The payment has been processed!
            if (result.paymentIntent.status === 'succeeded') {
                setLoader(false);
                updateProfile();
                toast.success("Payment successfull!")
                navigate('/app/user-dashboard', { replace: true })
                // Show a success message to your customer
                // There's a risk of the customer closing the window before callback
                // execution. Set up a webhook or plugin to listen for the
                // payment_intent.succeeded event that handles any business critical
                // post-payment actions.
            }
        }
    };
    return (
        <div className="checkout-form">
            <div className="rightSideBox w-50">
                <p>Amount: ${selectedPrice}</p>
                <form onSubmit={handleSubmit}>
                    <div className="mt-2">
                        <p>Card details</p>
                        <CardElement options={CARD_ELEMENT_OPTIONS} />
                    </div>
                    <Button type="submit" className='submit_button mt-4' disabled={!stripe || !elements || isLoading}>
                        {isLoading ? (
                            <div className='d-flex justify-content-center'>
                                <center>
                                    <div
                                        style={{ width: "1rem", height: "1rem", color: "#1f7e78" }}
                                        class="spinner-border me-2 mb-4"
                                        role="status"
                                    />
                                </center>Pay</div>) : "Pay"}

                    </Button>
                    {renderError('Please enter card details! ', error)}
                </form>
            </div>
        </div>
    );
};
export default CheckoutForm